import { OnboardingContainer } from "Containers/AuthContainer/OnboardContainer/OnboardingContainer";
import React from "react";

export const Onboarding = () => {
  return <OnboardingContainer />;
};
